export default __webpack_public_path__ + "static/media/Neck.80972564.svg";